export default __webpack_public_path__ + "static/outline-heritage-ea5bc8358f339aa47a8a118c846db2a5.svg";